import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NewReview, ReviewMetrics, ReviewsState, Reviews } from './model';
import { Cleaner } from '../cleaners/model';
import { REVIEWS_ACTIONS, REVIEWS_LOADERS } from './utils';

const initialState: ReviewsState = {
  cleanerReviews: [],
  loaders: {},
  reviewMetrics: [],
};

export const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    fetchReviewsSuccess(state, { payload }: PayloadAction<Reviews>) {
      state.cleanerReviews = payload;
    },
    setHasPendingReviews: (state, { payload }: PayloadAction<boolean>) => {
      state.hasPendingReviews = payload;
    },
    toggleLoader(
      state,
      {
        payload: { key, value },
      }: PayloadAction<{ key: REVIEWS_LOADERS; value: boolean }>,
    ) {
      state.loaders[key] = value;
    },
    fetchMetricsSuccess(state, { payload }: PayloadAction<ReviewMetrics>) {
      state.reviewMetrics = payload;
    },
  },
});

const extraActions = {
  fetchReviewsByCleanerId: createAction<Cleaner['_id']>(
    REVIEWS_ACTIONS.GET_REVIEWS,
  ),
  insertNewReview: createAction<
    NewReview & { cleanerId: string; bookingId: string }
  >(REVIEWS_ACTIONS.INSERT_NEW_REVIEW),
  fetchMetrics: createAction(REVIEWS_ACTIONS.FECTH_METRICS),
  checkPendingReviews: createAction(REVIEWS_ACTIONS.CHECK_PENDING_REVIEWS),
};

export const {
  fetchReviewsByCleanerId,
  insertNewReview,
  fetchReviewsSuccess,
  toggleLoader,
  fetchMetrics,
  fetchMetricsSuccess,
  setHasPendingReviews,
  checkPendingReviews,
} = {
  ...reviewsSlice.actions,
  ...extraActions,
};

export const reviewReducer = reviewsSlice.reducer;
